import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import classes from "./usage.module.css";
import CircularProgress from "@mui/material/CircularProgress";
import { config } from "../../Network_Calls/config";

const Usage = () => {
  const [lastLoginData, setLastLoginData] = useState([]);
  const [lastDataViewData, setLastDataViewData] = useState([]);
  const [loading, setLoading] = useState(true);

  const formatCustomDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(date).toLocaleDateString('en-IN', options).replace(/-/g, '/');
  };

  const getUserOrganizationId = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URL + "/customer/get-user-organization-id",
        {
          ...config(),
        }
      );
      let organizationId = response.data.organization_id[0].organization_id
      getLastLoginByUser(organizationId);
      getLastDataViewByUser(organizationId);
    } catch (error) {
      console.error("Error fetching last login data:", error);
    }
  };

  const getLastLoginByUser = async (organizationId) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URL + `/customer/get-last-login-by-user?organization_id=${organizationId}`,
        {
          ...config()
        }
      );

      const formattedData = response.data.lastLoginData.map(user => ({
        ...user,
        last_login: formatCustomDate(user.last_login)
      }));

      setLastLoginData(formattedData);
    } catch (error) {
      console.error("Error fetching last login data:", error);
    }
  };

  const getLastDataViewByUser = async (organizationId) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URL + `/customer/get-last-data-view-by-user?organization_id=${organizationId}`,
        {
          ...config()
        }
      );

      const formattedData = response.data.lastDataViewData.map(user => ({
        ...user,
        last_data_view: formatCustomDate(user.last_data_view)
      }));

      setLastDataViewData(formattedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching last data view data:", error);
    }
  };

  useEffect(() => {
    getUserOrganizationId();
  }, []);

  return (
    <div>
      <Navbar />
      <div className={classes.container}>
        {loading ? (
          <CircularProgress size={30} thickness={5} sx={{color:"#1FAFC2"}} loading={loading} />
        ) : (
          <div style={{marginBottom:"5rem"}}>
            <div className={classes.text}>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1, marginRight: "5rem" }}>
                  <h5>Last Login by User</h5>
                  <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                    <thead>
                      <tr>
                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left", backgroundColor: "#1FAFC2" }}>User</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left", backgroundColor: "#1FAFC2" }}>Last Login Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lastLoginData.map((login, index) => (
                        <tr key={index}>
                          <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>{login.name}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>{login.last_login}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div style={{ flex: 1 }}>
                  <h5>Last View by User</h5>
                  <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                    <thead>
                      <tr>
                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left", backgroundColor: "#1FAFC2" }}>User</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left", backgroundColor: "#1FAFC2" }}>Last Data View Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lastDataViewData.map((view, index) => (
                        <tr key={index}>
                          <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>{view.name}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>{view.last_data_view}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Usage;